var URI = require('urijs');
import Choices from "choices.js";
import LocaleHost from '../../../../scripts/classes/LocaleHost';

var FormBasic = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.$form = this.options.$el.find("form");
  this.$submitButton = this.options.$el.find("[data-circle-button]");

};

/**
 * Init
 * @return {[type]} [description]
 */
FormBasic.prototype.init = function(){

  var self = this;

	let formieSubmitHandler = null;

	this.$form.on('onBeforeFormieSubmit', function(e) {
		formieSubmitHandler = e.detail.submitHandler;

        // set the language field that will be used for determining translations in email notifications
        var $formLanguageField = self.options.$el.find('[name="fields[formLanguage]"]');

        if ($formLanguageField.length) {
            var urlParams = new URLSearchParams(window.location.search);
            var formLanguageParam = urlParams.get('formLanguage');

            if (formLanguageParam) {
                $formLanguageField.val(formLanguageParam);
            } else {
                $formLanguageField.val(LocaleHost.getLocale(window.location.hostname) || 'en');
            }
        }

	});

  // submit button
  this.$form.on('onFormieValidate', function(e) {

  	
		// e.stopImmediatePropagation();
  	let data = e.detail;
  	self.$submitButton.addClass("is-loading");

    if(data.invalid){

			console.log("error");
			e.preventDefault();

    }else{

			if(typeof MsCrmMkt !== "undefined" && self.options.$el.data('formHandle') == 'updatePreferences') {
				MsCrmMkt.MsCrmFormLoader.sendFormCaptureToCrm(e.currentTarget);
				console.log('submittedddd');
			}


		}

  });

  if ( this.options.$el.find('[data-fui-id="update-preferences-country"]').length && this.options.$el.find('[data-fui-id="update-preferences-country-dropdown"]').length ) {

    var countryChoices = new Choices( self.options.$el.find('[data-fui-id="update-preferences-country-dropdown"]')[0] );

    this.options.$el.find('[data-fui-id="update-preferences-country-dropdown"]').on('change', function() {
console.log('changed');
      var dropdownValue = $(this).val();
      self.options.$el.find('[data-fui-id="update-preferences-country"]')[0].value = dropdownValue;

    });

  }

  /*
  // update preferences form, add custom html for interests
  if (self.options.$el.data('formHandle') == 'updatePreferences')
  {

    // add additional text to our topic checkboxes
    var $insuranceLabel = self.options.$el.find('#fields-update-preferences-interests-wrap label[for="fields-update-preferences-interests-insurance"]');
    var $advisoryLabel = self.options.$el.find('#fields-update-preferences-interests-wrap label[for="fields-update-preferences-interests-advisory"]');

    $insuranceLabel.html(`
      <div class="label-content-container">
        <span class="text">Insurance</span>
        <ul>
          <li>Property &amp; Infrastructure Damage</li>
          <li>Building Code Insights</li>
          <li>Forensic Architecture &amp; Engineering</li>
          <li>Environmental, Health, &amp; Safety</li>
          <li>Equipment</li><li>Forensic Accounting</li>
          <li>Water &amp; Fire Restoration</li>
        </ul>
      </div>
    `);

    $advisoryLabel.html(`
      <div class="label-content-container">
        <span class="text">Advisory</span>
        <ul>
          <li>Construction Claims</li>
          <li>Scheduling</li>
          <li>Program &amp; Project Management</li>
          <li>Building Forensics</li>
          <li>Surety</li>
          <li>Quantity Surveying</li>
        </ul>
      </div>
    `);

  }
  */

  // set up choices on language dropdown
  /*
  if (self.options.$el.find('#fields-update-preferences-what-is-your-preferred-language').length) {
    var statusChoices = new Choices( self.options.$el.find('#fields-update-preferences-what-is-your-preferred-language')[0] );
  }
  */

};

export default  FormBasic;
